import React from 'react';
import { Row, Col, Button, FormControl, InputGroup, FormGroup, Form } from 'react-bootstrap';
import Select from 'react-select';
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios';
import Dialog from 'react-bootstrap-dialog';
import constants from '../../util/constants'
import './style.scss'

const { API_BASE_URL } = constants;

class CustomerTransportation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            chosenValue: null,
            currentWeight: 0,
            header: this.props.header,
            saveLoadMessage: 'testingyesyes',
            isSuccess: false,
            isError: false

        };

        this.onInputChanged = this.onInputChanged.bind(this);
        this.onSelectChanged = this.onSelectChanged.bind(this);
        this.saveMaxLoad = this.saveMaxLoad.bind(this);
        this.updateMaxLoad = this.updateMaxLoad.bind(this);

    }

    onSelectChanged(value) {
        this.setState({
            chosenValue: value,
            currentWeight: value.object.MAX_LOAD === undefined ? 0 : value.object.MAX_LOAD
        })
        this.props.onWeightChanged(value.object.MAX_LOAD === undefined ? 0 : value.object.MAX_LOAD);
    };

    onInputChanged(event) {
        this.setState({ currentWeight: event.target.value });
        this.props.onWeightChanged(event.target.value);
    };

    saveMaxLoad(event) {
        if (this.state.chosenValue === null || this.state.chosenValue.object === null) return;
        this.dialog.show({
            title: "Update transporter maxweight",
            body: `This will update the max weight for the transporter ${this.state.chosenValue.object.SHORT_NAME} with the country code ${this.state.chosenValue.object.COUNTRY_CODE}, and will be visible for all customers. Are you sure you want to do this?`,
            actions: [
                Dialog.CancelAction(() => {
                    return;
                }),
                Dialog.OKAction(() => {
                    this.updateMaxLoad();
                })
            ]
        })
    };

    updateMaxLoad() {
        let currentValue = this.state.chosenValue.object;
        currentValue.MAX_LOAD = this.state.currentWeight;

        this.setState({ isError: false, isSuccess: false, saveLoadMessage: '' })

        axios.post(API_BASE_URL + "Allocation/SaveMaxLoad", this.state.chosenValue.object, { headers: this.state.header })
            .then(result => {
                this.setState({ isError: false, isSuccess: true, saveLoadMessage: 'Success' })
            })
            .catch(error => {
                this.setState({ isError: true, isSuccess: false, saveLoadMessage: 'Error' })
            })
    }

    render() {
        const transporters = this.props.transporterData;
        const transporterOptions = transporters.map((value) => { return value === undefined ? null : { label: value.SHORT_NAME + ' - ' + value.MAX_LOAD, value: value.TRANSPORTER_CODE, object: value } })

        return (
            <div className="transport">
                <Dialog ref={(el) => { this.dialog = el}} />
                <Form inline >
                    <FormGroup>
                        <InputGroup>
                            {this.state.isSuccess &&
                                <div className="errorContainer">
                                    <label>{this.state.saveLoadMessage}</label>
                                </div>
                            }
                            {this.state.isError &&
                                <div className="danger errorContainer">
                                    <label>{this.state.saveLoadMessage}</label>
                                </div>
                            }


                            <InputGroup.Addon>Transporter (kg)</InputGroup.Addon>
                            <Select isSearchable={true}
                                styles={{
                                    valueContainer: (provided) => ({
                                        ...provided,
                                        height: '32px',
                                        minWidth: '150px'
                                    }),
                                }}
                                options={transporterOptions}
                                isClearable={false} m
                                menuContainerStyle={{ zIndex: 5 }}
                                onChange={(event) => this.onSelectChanged(event)}
                                value={this.state.chosenValue}
                            />
                        </InputGroup>
                        <FormControl type="text" placeholder="Max weight" value={this.state.currentWeight ? this.state.currentWeight : ''} onChange={(event) => this.onInputChanged(event)} />

                    </FormGroup>
                </Form>
                <Button bsStyle="primary" className="btn-sm" disabled={this.state.chosenValue === null || (this.state.chosenValue !== null && isNaN(this.state.currentWeight))} onClick={this.saveMaxLoad}>
                    Save max weight
                </Button>
            </div>
        );
    }
}


export default CustomerTransportation;